import httpClient from '@api/httpClient'
import type { TrackerEvent } from '@models/tracker'
import { trackerUrls } from './constants'

const getTrackerLatestEvent = async (routeId: number) => {
  const { data } = await httpClient.get<TrackerEvent>(
    trackerUrls.trackerLatestEvent,
    { params: { routeId } },
  )

  return data
}

export default {
  getTrackerLatestEvent,
}
